// Crisp SVG map markers (replaces the legacy maps.google.com PNG dots).
// Personal places are teardrop pins coloured by category/status; program
// places are smaller circles so the two layers read differently at a glance.
// These builders need window.google (call them only inside a loaded map).

export const STATUS_COLORS = {
  mustgo: '#ef5350',
  luxury: '#ffca28',
  healthy: '#66bb6a',
  visited: '#8d9bb3',
  default: '#ff7043', // want-to-try / uncategorised
};

// Material "place" pin outline, 24x24 viewbox, tip at (12, 22.5)
const PIN_PATH =
  'M12 1C7.3 1 3.5 4.8 3.5 9.5c0 5.9 7.1 12.6 7.9 13.3.3.3.9.3 1.2 0 .8-.7 7.9-7.4 7.9-13.3C20.5 4.8 16.7 1 12 1zm0 12a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7z';

export function statusColor(place) {
  if (place.visited) return STATUS_COLORS.visited;
  return STATUS_COLORS[place.category] || STATUS_COLORS.default;
}

export function pinIcon(color, { selected = false, mobile = false } = {}) {
  // Mobile needs significantly larger hit areas: desktop mouse clicks are
  // precise, finger taps are not. Material guidelines recommend ≥44px targets.
  const base = mobile ? 2.0 : 1.55;
  const sel  = mobile ? 2.7 : 2.1;
  return {
    path: PIN_PATH,
    fillColor: color,
    fillOpacity: 1,
    strokeColor: selected ? '#ffffff' : '#0d0d14',
    strokeWeight: selected ? 2.4 : 1.3,
    scale: selected ? sel : base,
    anchor: new window.google.maps.Point(12, 22.5),
    labelOrigin: new window.google.maps.Point(12, 9.5),
  };
}

export function circleIcon(color, { selected = false, mobile = false } = {}) {
  const base = mobile ? 8.5 : 6.5;
  const sel  = mobile ? 11  : 9;
  return {
    path: window.google.maps.SymbolPath.CIRCLE,
    fillColor: color,
    fillOpacity: 0.95,
    strokeColor: selected ? '#ffffff' : '#0d0d14',
    strokeWeight: selected ? 2.6 : 1.5,
    scale: selected ? sel : base,
  };
}

// A soft halo rendered as a second marker beneath the selected pin, so the
// active pin reads at a glance even when nearby markers overlap.
export function haloIcon() {
  return {
    path: window.google.maps.SymbolPath.CIRCLE,
    fillColor: '#ffffff',
    fillOpacity: 0.18,
    strokeColor: '#ffffff',
    strokeOpacity: 0.5,
    strokeWeight: 1,
    scale: 18,
  };
}

export function userLocationIcon() {
  return {
    path: window.google.maps.SymbolPath.CIRCLE,
    fillColor: '#4285f4',
    fillOpacity: 1,
    strokeColor: '#ffffff',
    strokeWeight: 2.5,
    scale: 7,
  };
}
